import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PayStartRq } from '@app/dto/PayStartRequest';
import { StartBillingResponse } from '@app/interfaces/StartBillingResponse';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {

  constructor(private http: HttpClient) { }

  GetDeviceInfo() {
    return this.http.get(`${environment.exiBackendUrl}/api/exi/devicedetector/getdevicedata` )
  }

}